import { render, staticRenderFns } from "./ConversationTradeEvent.vue?vue&type=template&id=08cf7367&scoped=true&"
import script from "./ConversationTradeEvent.vue?vue&type=script&lang=js&"
export * from "./ConversationTradeEvent.vue?vue&type=script&lang=js&"
import style0 from "./ConversationTradeEvent.vue?vue&type=style&index=0&id=08cf7367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf7367",
  null
  
)

export default component.exports